// import { getAbortSignal } from "@/request/request";
import axios from "axios";
import { manualStopNext } from '@/utils/base/base';

export function getAbortSignal(){
  return new AbortController().signal;
}

async function request(
  axiosRequestConfig,
  params
){
  try {
    const { data: resBody, status } = await axios({
      baseURL: "http://api.youyuesp.com",
      //baseURL: "http://localhost:49345",
      ...axiosRequestConfig,
      [axiosRequestConfig.method === "POST" ? "data" : "params"]: {
        ...params,
      },
    });

    console.info('resBody', resBody)

    switch (status) {
      case 200:
        // if (resBody.code === -99) {
        //   const location = window.location;
        //   const { origin, pathname, hash } = location;

        //   location.replace(
        //     `${origin}${pathname}/#/client/login?redirectUrl=${hash.replace(
        //       "#",
        //       ""
        //     )}`
        //   );
        //   throw String("请先登录");
        // }
        if (resBody.returnCode !== 0) throw resBody.message;
        return resBody;
      case 500:
        throw String("网络错误");
      default:
        throw String("请求失败");
    }
  } catch (error) {
    console.error("request-fail", error);
    if(error && typeof error === 'object'){
      if( error.message === 'canceled') {
        throw String(`${manualStopNext}: 取消网络`)
      }
    }
    throw error;
  }
}


export {request}